import { FC } from 'react'

import {
  Condition,
  ConditionalOperator,
  ConditionPropertyEditorComponentProps
} from 'Automations/nodeDefinitions/conditions'
import { InputSelectControlField } from 'Automations/nodeDefinitions/components'
import { ValidationResult } from 'Automations/nodeDefinitions/validation'
import {
  appendTestId,
  useCustomerOperatorState
} from './CustomerPropertyEditor.helpers'

type Props = {
  'data-testid'?: string
  operator: string
  operators: Record<string, ConditionalOperator>
  siblingConditions: Array<Condition>
  onChange: ConditionPropertyEditorComponentProps['onChange']
  validationErrors: ValidationResult[] | undefined
  initiallyOpen?: boolean
}

/**
 * The CUSTOMER operator dropdown, shared by every operator-specific editor so
 * the control behaves identically whichever operator is selected. The options
 * (identity operators plus one per custom-property key) come from
 * `useCustomerOperatorState`. Custom-property keys can be longer than this
 * narrow column, so the dropdown is allowed to grow past the control to fit
 * them, between 124px and 200px.
 */
export const CustomerOperatorSelect: FC<Props> = ({
  'data-testid': dataTestId,
  operator,
  operators,
  siblingConditions,
  onChange,
  validationErrors,
  initiallyOpen
}) => {
  const { operatorOptions, onOperatorChange } = useCustomerOperatorState({
    operator,
    operators,
    siblingConditions,
    onChange
  })

  return (
    <InputSelectControlField
      data-testid={appendTestId(dataTestId, 'operator')}
      placeholder="Select..."
      options={operatorOptions}
      value={operator ?? ''}
      onChange={onOperatorChange}
      validationErrors={validationErrors}
      initiallyOpen={initiallyOpen}
      matchWidth={false}
      menuWidth={{ min: '124px', max: '200px' }}
    />
  )
}
